module.exports = __webpack_public_path__ + "img/PDAC1_CD8T.9b1e48e4.png";